/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanUtilizationMetricsData {
    getFixupPrototypeFunction() { return SavingsPlanUtilizationMetricsData.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanUtilizationMetricsData>): SavingsPlanUtilizationMetricsData {
        let obj = Object.assign(new SavingsPlanUtilizationMetricsData(), model);
        SavingsPlanUtilizationMetricsData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanUtilizationMetricsData>): SavingsPlanUtilizationMetricsData {
        if (!model) return null;
        return SavingsPlanUtilizationMetricsData.newInstance(<SavingsPlanUtilizationMetricsData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanUtilizationMetricsData) {
        if (!obj) return;

        models.SavingsPlanUtilizationMetricsData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanUtilizationMetricsData): boolean {
        Object.setPrototypeOf(obj, SavingsPlanUtilizationMetricsData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.SavingsPlanUtilizationMetric.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.SavingsPlanUtilizationMetric>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
